import { memo } from 'react';
import { useInView } from 'react-intersection-observer';

import { Spinner } from '@air/primitive-spinner';

import { useLoadMoreLogic } from '~/components/LoadMoreSpinner/useLoadMoreLogic';

type KanbanColumnLoadMoreItemsProps = {
  isLoading: boolean;
  loadMore: () => void;
};

export const KanbanColumnLoadMoreItems = memo(({ loadMore, isLoading }: KanbanColumnLoadMoreItemsProps) => {
  const { ref, inView } = useInView({
    threshold: 0.01,
    rootMargin: '300px',
  });

  useLoadMoreLogic({ loadMore, isVisible: inView, isLoading });

  return (
    <div ref={ref} className="flex h-[150px] items-center justify-center py-1.5">
      <Spinner className="size-8 text-teal-9" />
    </div>
  );
});

KanbanColumnLoadMoreItems.displayName = 'KanbanColumnLoadMoreItems';
